import styled from '@emotion/styled'

import theme from 'styles/theme'

export const StyledCard = styled.div`
  background-color: ${theme.token.var('colors.green.a150')};
  border-radius: ${theme.token.var('borderRadius.big')};
  padding: 14px 18px 18px 18px;
  color: ${theme.token.var('colors.white')};
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

export const Link = styled.a`
  color: ${theme.token.var('colors.white')};
  font-weight: bold;
  font-size: ${theme.token.var('fontSizes.sm')};
  margin-left: 50px;
  cursor: pointer;
`

export const BundleItems = styled.div`
  margin-top: 24px;
  margin-bottom: 36px;
  width: 100%;
`
